import * as React from "react";
import { forwardRef } from "react";
const SvgInfoItalicOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12Z",
	stroke: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "m7.871 5.963-1.69.204-.061.27.332.06c.217.049.26.124.213.332L6.12 9.293c-.144.638.077.938.596.938.403 0 .87-.18 1.082-.425l.065-.296a.839.839 0 0 1-.506.175c-.203 0-.277-.137-.225-.379l.74-3.343Zm.052-1.483a.698.698 0 0 1-.216.502.753.753 0 0 1-.522.208.753.753 0 0 1-.523-.208.697.697 0 0 1-.216-.502c0-.189.078-.37.216-.503a.753.753 0 0 1 .523-.208c.195 0 .383.075.522.208a.697.697 0 0 1 .216.503Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgInfoItalicOutlined);
export default ForwardRef;
